export const getInitialLang = (): 'en' | 'zh' => {
    if (typeof window !== 'undefined') {
      const sp = new URLSearchParams(window.location.search)
      const urlLang = sp.get('lang')
      if (urlLang) {
        const v =
          urlLang.toLowerCase() === 'cn' || urlLang.toLowerCase() === 'zh'
            ? 'zh'
            : 'en'
        document.cookie = `lang=${v};path=/;max-age=31536000`
        return v as 'en' | 'zh'
      }
      const m = document.cookie.match(/(?:^|; )lang=([^;]+)/)
      if (m) {
        return m[1] === 'zh' || m[1] === 'cn' ? 'zh' : 'en'
      }
    }
    return 'en'
  }